enum ROUTES {
  MAIN = "/",
  LOGIN = "/login",
  CODE = "/code",
  REGISTRATION = "/registration",
  COMPANIES_BIND = "/companies-bind",
  SIGN_PERSONAL_DATA = "/sign-personal-data",
  HELP = "/help",
  PROFILE = "/profile",
  TASKS = "/tasks",
  TASKS_ID = "/tasks/:taskId",
  TRANSACTIONS_ID = "/transactions/:transactionsId",
  SING_ACT_ID = "/sing-act/:actId",
  CONTRACTS = "/contracts",
  SING_CONTRACTS_ID = "/contracts/:contractId",
  REQUESTS = "/r",
  REQUEST_ID = "/r/:requestNumber",
  RA = "/ra/:number",
  IDENTITY_VERIFICATION = "/identity-verification",
  IDENTITY_VERIFICATION_MAIN = "/identity-verification-main",
}

export default ROUTES;
